module.exports = __webpack_public_path__ + "static/acabado-2f3ceef1e93ef7ce6f73dbe9078dfedd.jpg";